import { PaymentCardBrand } from "../api/payment.api";

/**
 * Converts a PaymentCardBrand type to human readable text
 *
 * @param brand The brand to convert
 */
export const paymentCardBrandTypeToHuman = (brand: PaymentCardBrand): string => {
  switch (brand) {
    case PaymentCardBrand.VISA:
      return "Visa";
    case PaymentCardBrand.MASTERCARD:
      return "MasterCard";
    case PaymentCardBrand.AMEX:
      return "American Express";
    case PaymentCardBrand.DISCOVER:
      return "Discover";
    case PaymentCardBrand.UNION:
      return "UnionPay";
    case PaymentCardBrand.JCB:
      return "JCB";
    case PaymentCardBrand.DC:
      return "Diners Club";
    case PaymentCardBrand.CB:
      return "Cartes Bancaires";
    default:
    case PaymentCardBrand.UNKNOWN:
      return "Unknown";
  }
};